// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    focusedItemText,
    headerText,
    itemText,
    linkStyles,
    titleText,
} from "@vanmeter/App/SharedStyles/AutoCompleteSharedStyles";
import { autocompleteCategoriesStyles } from "@vanmeter/Overrides/Widgets/Header/AutocompleteCategories";

autocompleteCategoriesStyles.headerText = headerText;

autocompleteCategoriesStyles.link = linkStyles;

autocompleteCategoriesStyles.categoryItemText = {};

autocompleteCategoriesStyles.categoryItemText = {
    ...itemText,
};

autocompleteCategoriesStyles.title = {
    ...titleText,
};

autocompleteCategoriesStyles.inText = {
    ...itemText,
};

autocompleteCategoriesStyles.focusedCategoryItemText = {
    ...focusedItemText,
};

autocompleteCategoriesStyles.focusedLink = linkStyles;
